<template>
  <div class="second-bar">
    <div class="grid">
      <div class="grid__left">
        <div class="wrapper-carousel">
          <div class="scene">
            <div ref="carousel" class="carousel">
              <div
                v-for="(item, index) in cellCount"
                :key="index"
                class="carousel__cell reflection"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <button @click="next(), incrementActiveIndex()" class="next-button">
        <i class="fal fa-chevron-right"></i>
      </button>
      <div class="grid__right">
        <img class="bg-img" :src="require('@/assets/hitech/bgSecondBar.png')" />
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url },
            })
          "
          v-for="(item, index) in list"
          :key="item.id"
          class="description"
        >
          <transition name="fade-up" appear>
            <div class="top-descr" v-show="activeIndex == index">
              <span class="category">{{ item.sub_category.name }}</span>
              <h3 class="title limited-text">{{ item.title }}</h3>
            </div>
          </transition>
          <transition name="fade-down" appear>
            <div class="bottom-descr" v-show="activeIndex == index">
              <p
                v-html="changeFirstLetter(item.brief)"
                class="brief limited-text"
              ></p>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }}</span>
              </div>
            </div>
          </transition>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import { onBeforeUnmount, onMounted, ref } from "vue";

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const carousel = ref(null);
    const data = ref(props.list);
    const cellWidth = ref(0);

    let selectedIndex = 0;
    let radius, theta;

    const activeIndex = ref(0);
    const incrementActiveIndex = (to = 1) => {
      activeIndex.value =
        activeIndex.value + to < 0
          ? (activeIndex.value = props.list.length - 1)
          : activeIndex.value + to > props.list.length - 1
          ? 0
          : activeIndex.value + to;
    };

    function rotateCarousel() {
      let angle = theta * selectedIndex * -1;
      carousel.value.style.transform =
        "translateZ(" + -radius + "px) rotateY(" + angle + "deg)";
    }
    data.value = data.value.concat(data.value).concat(data.value);
    let cellCount = data.value.length;
    let cells;

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function () {
          resizeTimeout = null;
          if (typeof window !== "undefined") {
            if (window.innerWidth > 992) {
              cellWidth.value = window.innerWidth * 0.28;
            }
            if (window.innerWidth <= 992) {
              cellWidth.value = window.innerWidth * 0.5;
            }
            changeCarousel();
          }
          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    onMounted(() => {
      if (window.innerWidth > 992) {
        cellWidth.value = window.innerWidth * 0.28;
      }
      if (window.innerWidth <= 992) {
        cellWidth.value = window.innerWidth * 0.5;
      }
      cells = carousel.value.querySelectorAll(".carousel__cell");
      changeCarousel();
      window.addEventListener("resize", resizeThrottler);
      carousel.value.addEventListener("touchstart", touchStart, false);
      carousel.value.addEventListener("touchend", touchEnd, false);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
    });

    function changeCarousel() {
      theta = 360 / cellCount;
      var cellSize = cellWidth.value;
      radius = Math.round(cellSize / 2 / Math.tan(Math.PI / cellCount));
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        if (i < cellCount) {
          // visible cell
          cell.style.opacity = 1;
          var cellAngle = theta * i;
          cell.style.background = `url(${data.value[i].image.medium})`;

          cell.style.backgroundRepeat = "no-repeat";
          cell.style.backgroundPosition = "center";
          cell.style.backgroundSize = "cover";

          cell.style.transform =
            "rotateY(" + cellAngle + "deg) translateZ(" + radius + "px)";
        } else {
          // hidden cell
          cell.style.opacity = 0;
          cell.style.transform = "none";
        }
      }
      rotateCarousel();
    }

    const next = () => {
      selectedIndex++;
      rotateCarousel();
    };
    const prev = () => {
      selectedIndex--;
      rotateCarousel();
    };

    //Swipe touch screen
    /* eslint-disable */
    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    const touchStart = (event) => {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
    };

    const touchEnd = (event) => {
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      handleGesture();
    };

    const handleGesture = () => {
      if (touchendX < touchstartX) {
        // console.log("Swiped left");
        next();
        incrementActiveIndex();
      }

      if (touchendX > touchstartX) {
        // console.log("Swiped right");
        prev();
        incrementActiveIndex(-1);
      }
    };
    /* eslint-enable */

    return {
      carousel,
      cellCount,
      next,
      prev,
      incrementActiveIndex,
      activeIndex,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.second-bar {
  width: 100%;
  padding: 3rem 0;
}

.grid {
  position: relative;
  width: 90%;
  height: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  align-items: center;
  &__left {
    grid-column: 1 / span 7;
    grid-row: 1;

    overflow: hidden;
    position: relative;
    // height: 100%;
  }
  &__right {
    grid-column: 9 / span 4;
    grid-row: 1;
    position: relative;
    top: 50%;
    transform: translateY(-44%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .bg-img {
      background: transparent;
      position: absolute;
      width: 70%;
      height: auto;
      top: 30%;
      left: 45%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }
  }
  .category {
    font-family: Roboto;
    font-weight: 500;
    font-size: 1em;
    font-weight: bold;
    color: rgba(205, 205, 205, 0.5);
  }
  .title {
    font-family: 'Noto Serif', serif;
    font-weight: 600;
    font-size: 1.9em;
    line-height: 1.3;
    margin-bottom: 2rem;
  }
  .brief {
    font-family: Roboto;
    font-size: 1.25em;
    line-height: 140%;
    --snup: 4;
  }
  .data-news {
    text-align: right;
    color: rgba(205, 205, 205, 0.5);
    color: var(--primary-font-color);
    line-height: 2;
  }
}

.description {
  height: 100%;
  .top-descr {
    position: absolute;
    bottom: 60%;
  }
  .bottom-descr {
    position: absolute;
    // top: 50%;
    top: 40%;
  }
}

// Carousel
.carousel {
  left: -32%;
}
.wrapper-carousel {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // left: -20%;
}
.scene {
  margin: 0rem auto 8rem;
  width: 28vw;
  height: 18vw;
  position: relative;
  perspective: 1000px;
  padding-bottom: 40%;
  transform: translateX(40%);
  left: -28.5%;
}

.carousel {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
  /* transform: translateZ(-288px); */
  transition: transform 0.5s;
}

.carousel__cell {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 10px;
  top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.next-button {
  // position: absolute;
  // left: 57%;
  // top: 50%;
  // transform: translate(-22%,-135%);
  transform: translate(-70%, -80%);
  grid-column: 8 / span 1;
  grid-row: 1;
  z-index: 2;
  align-self: center;
  justify-self: start;
  height: 50px;
  width: 50px;
  background: transparent;
  color: #8c0134;
  font-size: 3em;
  cursor: pointer;
}
.fade-up-enter-active,
.fade-down-enter-active,
.fade-up-leave-active,
.fade-down-leave-active {
  transition: all 0.5s;
}

.fade-up-enter-from {
  opacity: 0;
  transform: translateY(-100%);
}
.fade-down-enter-from {
  opacity: 0;
  transform: translateY(100%);
}

.fade-up-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
.fade-down-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
.reflection {
  background-position: bottom;
  &::after {
    content: "";
    background: inherit;
    width: inherit;
    height: 28%;
    position: absolute;
    bottom: -30%;
    transform: scaleY(-1);
    background-position: bottom;
    opacity: 0.2;
    backdrop-filter: blur(2px);
  }
  &::before {
    content: "";
    width: inherit;
    height: 28%;
    position: absolute;
    bottom: -30%;
    background: linear-gradient(
      to bottom,
      rgba(250, 250, 250, 0.08),
      rgb(18, 18, 18)
    );

    z-index: 1;
  }
}
@media screen and (max-width: 1366px) {
  .next-button {
    grid-column: 8;
    // transform: translateY(0) translateX(50%);
  }
}

@media screen and (max-width: 992px) {
  .second-bar {
    padding-top: 0;
    padding-bottom: 1rem;
  }
  .grid {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto;
    &__left {
      grid-column: span 6;
      overflow: visible;
    }
    &__right {
      grid-column: span 6;
      grid-row: 2;
      top: 0px;
      position: relative;
      height: 300px;
      margin-top: 3rem;
      .bg-img {
        top: 0%;
        transform: translate(-50%, 0%);
        left: 50%;
        object-fit: fill;
        height: 90%;
        width: 100%;
      }
    }
    .title {
      font-size: 1.5em;
      --snup: 2;
    }
    .brief {
      font-size: 1.15em;
    }
  }
  .reflection {
    &::after {
      display: none;
    }
  }
  .wrapper-carousel {
    width: 110%;
  }
  .scene {
    margin: 0 0 1.5rem !important;
    // margin: 0rem auto 8rem;
    width: 50vw;
    height: 40vw;
    position: relative;
    perspective: 1300px;
    perspective-origin: left left;
    padding-bottom: 0;
    margin: 0;
    transform: translateX(40%);
    left: -25%;
  }
  .next-button {
    transform: translateY(0) translateX(50%);
    color: #b30042;
  }
  .carousel {
    left: 0;
    &__cell {
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 21;
        background: rgba(0, 0, 0, 0.337);
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .next-button {
    grid-column: 6;
    font-size: 1.5em;
  }
  .grid {
    &__left {
      grid-column: 1 / span 6;
    }
  }
  .wrapper-carousel {
    width: 100%;
  }
  .scene {
    left: -30%;
  }
  .title {
    font-size: 19px !important;
  }
  .category {
    font-size: 14px !important;
  }
  .top-descr {
    width: 80%;
    margin: 0 auto;
    left: 5vw;
  }
  .brief {
    font-size: 16px !important;
  }
}
.brief::first-letter {
  color: #961964 !important;
  font-weight: bold;
  display: inline-block;
}
</style>
